import {
  HEX_000000,
  HEX_1EB785,
  HEX_292D38,
  HEX_2F5278,
  HEX_3B93EE,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_66AAFF,
  HEX_7F869D,
  HEX_CED7E2,
  HEX_E2E5EB,
  HEX_E6444E,
  HEX_ECF4FF,
  HEX_FCFDFE,
} from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import {
  defineColor,
  defineShadow,
  ErrorFill,
  StatusNegative,
  StatusPositive,
  StatusWarning,
  SuccessFill,
  WarningFill,
} from '@tanium/react-theme-definition';

export const IconInfo = defineColor([HEX_477FBA, HEX_66AAFF]);
export const IconInfoFill = defineColor([HEX_ECF4FF, HEX_2F5278]);

export const IconSuccess = StatusPositive;
export const IconSuccessFill = SuccessFill;

export const IconError = StatusNegative;
export const IconErrorFill = ErrorFill;

export const IconWarning = StatusWarning;
export const IconWarningFill = WarningFill;

export const Text = defineColor([HEX_292D38, HEX_FCFDFE]);

export const SuccessShadow = defineShadow([
  `0 2px 0 ${getRgbString(HEX_1EB785, '30%')}`,
  `0 2px 4px ${getRgbString(HEX_000000, '11%')}`,
]);

export const InfoShadow = defineShadow([
  `0 2px 0 ${HEX_CED7E2}`,
  `0 2px 4px ${getRgbString(HEX_000000, '11%')}`,
]);

export const WarningShadow = InfoShadow;

export const ErrorShadow = defineShadow([
  `0 2px 0 ${getRgbString(HEX_E6444E, '25%')}`,
  `0 2px 4px ${getRgbString(HEX_000000, '11%')}`,
]);

export const DismissButtonFill = defineColor([HEX_7F869D, HEX_E2E5EB]);
export const DismissButtonHover = defineColor([HEX_3B93EE, HEX_66AAFF]);
export const DismissButtonActive = defineColor([HEX_3E4B68, HEX_477FBA]);
